/**
 * Page transitions with real URLs and full page loads (good for SEO): on an internal link,
 * a plum panel wipes up (CSS), then the browser navigates. The next page's <head> script sees
 * the sessionStorage flag and the panel wipes away while that page's hero animates in.
 */
const SKIP = /^(mailto:|tel:|sms:|javascript:)/i;

export function initTransitions() {
  const html = document.documentElement;

  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href]');
    if (!link || e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (link.target && link.target !== '_self') return;
    if (link.hasAttribute('download') || SKIP.test(link.getAttribute('href'))) return;

    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname.startsWith('/api/')) return;
    // Same page (including hash links): handled by the smooth-scroll code instead.
    if (url.pathname === location.pathname && url.search === location.search) return;

    e.preventDefault();
    try { sessionStorage.setItem('llol-transition', '1'); } catch (err) { /* private mode */ }
    html.classList.add('is-leaving');
    setTimeout(() => { location.href = url.href; }, 520);
  });

  // Coming back via the back/forward cache: make sure the panel is not stuck covering the page.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) html.classList.remove('is-leaving', 'is-arriving');
  });

  // Clear the arrival class once its CSS animation is done.
  if (html.classList.contains('is-arriving')) setTimeout(() => html.classList.remove('is-arriving'), 900);
}
